import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";
import { getDepartmentTypeById } from '../../../constants/dcDepartmentTypes';
import moment from "moment";

const renderRow = (department, onEdit, isReadOnly, isReceptionPoint) => { 
    const address = isReceptionPoint 
        ? department.GeoAddress && department.GeoAddress.X != null && department.GeoAddress.Y != null 
            ? `${department.GeoAddress.X}, ${department.GeoAddress.Y}` : ""
        : department.Address;
    return (<tr key={department.Id}>
        <td>{address}</td>
        <td>{department.FullName}</td>
        <td>{department.Phone}</td>
        <td>{department.IsActive ? 'Да' : 'Нет'}</td>
        <td>
            <Glyphicon glyph='pencil' 
            className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
            onClick={isReadOnly ? undefined : () => onEdit(department)} 
            title='Изменить' />
        </td>
    </tr>)
};

export const Table = ({ departments, fetching, onEdit, isReadOnly, isReceptionPoint }) => (
    <div>
        {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
        {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
        {fetching === fetchingState.FETCHED &&
            <table className='table table-hover'>
                <thead>
                    <tr>
                        <td>{isReceptionPoint ? "Координаты" : "Адрес"}</td>
                        <td>{isReceptionPoint ? "Название" : "ФИО"}</td>
                        <td>Телефон</td>
                        <td>Дейстует?</td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {departments.map(d => renderRow(d, onEdit, isReadOnly, isReceptionPoint))}
                </tbody>
            </table>}
    </div>);


// WEBPACK FOOTER //
// ./src/components/settings/departments/Table.jsx